import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentReturn({ cancel }) {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [state, setState] = useState(cancel ? "cancel" : "checking");

  useEffect(() => {
    if (cancel) return;
    const sid = params.get("session_id");
    if (!sid) { setState("error"); return; }
    let tries = 0;
    const poll = async () => {
      tries++;
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setState("success"); return; }
        if (["expired", "failed"].includes(data.payment_status) || tries > 10) { setState("error"); return; }
      } catch { if (tries > 10) { setState("error"); return; } }
      setTimeout(poll, 2000);
    };
    poll();
  }, []);

  return (
    <div className="min-h-screen grid place-items-center bg-muted/30 p-6">
      <Card className="max-w-md w-full p-8 text-center border-border shadow-sm">
        {state === "checking" && <><Loader2 className="animate-spin mx-auto text-emerald-500" size={40} /><h1 className="mt-4 text-xl font-bold">Zahlung wird bestätigt…</h1><p className="text-muted-foreground mt-2 text-sm">Einen Moment bitte.</p></>}
        {state === "success" && <><CheckCircle2 className="mx-auto text-emerald-500" size={48} /><h1 className="mt-4 text-2xl font-bold">Zahlung erfolgreich!</h1><p className="text-muted-foreground mt-2">Ihr 48h-Countdown läuft. Wir bearbeiten Ihre Anfrage.</p><Button data-testid="to-portal" className="mt-6 bg-emerald-500 hover:bg-emerald-600 text-white" onClick={() => nav("/portal")}>Zum Portal</Button></>}
        {state === "cancel" && <><XCircle className="mx-auto text-slate-400" size={48} /><h1 className="mt-4 text-2xl font-bold">Zahlung abgebrochen</h1><p className="text-muted-foreground mt-2">Ihre Anfrage wurde als Entwurf gespeichert.</p><Button className="mt-6 bg-[#0A192F] text-white" onClick={() => nav("/antrag")}>Erneut versuchen</Button></>}
        {state === "error" && <><XCircle className="mx-auto text-destructive" size={48} /><h1 className="mt-4 text-2xl font-bold">Etwas ist schiefgelaufen</h1><p className="text-muted-foreground mt-2">Bitte prüfen Sie Ihr Portal oder versuchen Sie es erneut.</p><Button className="mt-6 bg-[#0A192F] text-white" onClick={() => nav("/portal")}>Zum Portal</Button></>}
      </Card>
    </div>
  );
}
